import { lighten, styled, Toolbar, Typography } from "@mui/material";
import clsx from "clsx";

const PREFIX = "GroupTableToolbar";

const classes = {
	root: `${PREFIX}-root`,
	highlight: `${PREFIX}-highlight`,
	title: `${PREFIX}-title`,
	delete: `${PREFIX}-delete`,
};

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	[`&.${classes.root}`]: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},

	[`&.${classes.highlight}`]:
		theme.palette.mode === "light"
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark,
			  },

	[`& .${classes.title}`]: {
		flex: "1 1 100%",
	},
}));

export interface GroupTableToolbarProps {
	/**
	 * Additional toolbar buttons.
	 */
	children?: JSX.Element | JSX.Element[];
	title: string;
}

export const GroupTableToolbar = ({
	children,
	title,
}: GroupTableToolbarProps): JSX.Element => {
	return (
		<StyledToolbar
			className={clsx(classes.root, {
				[classes.highlight]: false,
			})}
		>
			<Typography
				className={classes.title}
				variant="h6"
				id="tableTitle"
				component="div"
			>
				{title}
			</Typography>

			{children}
		</StyledToolbar>
	);
};
